module.exports = __webpack_public_path__ + "img/ico-windows.9dba6c3.svg";